import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../constant/api";
import { Menu, LogOut, Building2, User, AlertTriangle } from "lucide-react";

export default function Topbar({ setIsOpen }) {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [userData, setUserData] = useState({ name: "Admin", role: "Super Admin" });
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("selectedBranch") || "");


const [selectedBranchName, setSelectedBranchName] = useState(
  localStorage.getItem("selectedBranchName") || ""
);

const fetchCompanies = async () => {
  try {
    const res = await api.get("/settings/getSettings");

    if (res.data && Array.isArray(res.data.data)) {
      const companyList = res.data.data;

      setCompanies(companyList);

      const savedBranchId =
        localStorage.getItem("selectedBranch");

      const savedBranchName =
        localStorage.getItem("selectedBranchName");

      if (savedBranchId) {
        const selectedCompany = companyList.find(
          (c) =>
            String(c.setting_id) ===
            String(savedBranchId)
        );

        if (selectedCompany) {
          setSelectedBranchName(
            selectedCompany.company_name || ""
          );

          localStorage.setItem(
            "selectedBranchName",
            selectedCompany.company_name || ""
          );
        }
      } else if (companyList.length > 0) {
        const firstCompany = companyList[0];

        const branchId =
          String(firstCompany.setting_id);

        const branchName =
          firstCompany.company_name || "";

        setSelectedBranch(branchId);
        setSelectedBranchName(branchName);

        localStorage.setItem(
          "selectedBranch",
          branchId
        );

        localStorage.setItem(
          "selectedBranchName",
          branchName
        );
      }
    }
  } catch (err) {
    console.error(
      "Fetch Companies Error:",
      err
    );
  }
};

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("user");
      const storedRole = localStorage.getItem("role") || localStorage.getItem("userRole");
      const storedName = localStorage.getItem("username") || localStorage.getItem("name");

      if (storedUser) {
        const parsed = JSON.parse(storedUser);
        setUserData({
          name: parsed.username || parsed.name || parsed.user_name || "Admin",
          role: parsed.role || parsed.user_role || "Staff"
        });
      } else if (storedName || storedRole) {
        setUserData({
          name: storedName || "Admin",
          role: storedRole || "Staff"
        });
      }
    } catch (e) {
      console.error("Error reading user info:", e);
    }

  const fetchCompanies = async () => {
  try {
    const res = await api.get("/settings/getSettings");

    if (res.data && Array.isArray(res.data.data)) {
      const companyList = res.data.data;

      setCompanies(companyList);

      const savedBranchId =
        localStorage.getItem("selectedBranch");

      const savedBranchName =
        localStorage.getItem("selectedBranchName");

      if (savedBranchId) {
        const selectedCompany = companyList.find(
          (c) =>
            String(c.setting_id) ===
            String(savedBranchId)
        );

        if (selectedCompany) {
          setSelectedBranchName(
            selectedCompany.company_name || ""
          );

          localStorage.setItem(
            "selectedBranchName",
            selectedCompany.company_name || ""
          );
        }
      } else if (companyList.length > 0) {
        const firstCompany = companyList[0];

        const branchId =
          String(firstCompany.setting_id);

        const branchName =
          firstCompany.company_name || "";

        setSelectedBranch(branchId);
        setSelectedBranchName(branchName);

        localStorage.setItem(
          "selectedBranch",
          branchId
        );

        localStorage.setItem(
          "selectedBranchName",
          branchName
        );
      }
    }
  } catch (err) {
    console.error(
      "Fetch Companies Error:",
      err
    );
  }
};
    fetchCompanies();
  }, []);

const handleBranchChange = (e) => {
  const branchId = e.target.value;

  const selectedCompany = companies.find(
    (c) =>
      String(c.setting_id) ===
      String(branchId)
  );

  const branchName =
    selectedCompany?.company_name || "";

  // React state
  setSelectedBranch(branchId);
  setSelectedBranchName(branchName);

  // LocalStorage
  localStorage.setItem(
    "selectedBranch",
    branchId
  );

  localStorage.setItem(
    "selectedBranchName",
    branchName
  );

  // IMPORTANT:
  // Same-tab components will receive this instantly
  window.dispatchEvent(
    new CustomEvent("branchChanged", {
      detail: {
        branchId,
        branchName,
      },
    })
  );


};

  return (
    <>
      {/* 🌟 ULTRA-PREMIUM HYBRID RESPONSIVE TOPBAR */}
      <div className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-slate-100 flex flex-col md:flex-row items-stretch md:items-center justify-between p-3 md:px-8 md:ml-64 gap-3 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.05)] md:h-20 transition-all duration-300">
        
        {/* ROW 1: MOBILE HEADER */}
        <div className="flex items-center justify-between md:justify-start gap-3 min-w-0">
          <div className="flex items-center gap-2.5">
            <button 
              onClick={() => setIsOpen(true)} 
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-xl bg-slate-50 border border-slate-200 active:scale-95 transition-all shadow-sm shrink-0"
            >
              <Menu size={18} className="text-slate-700" />
            </button>
            
            <div className="leading-tight">
              <h1 className="text-sm md:text-lg font-black text-slate-900 tracking-tight">
                TileMaster
              </h1>
              <p className="text-[10px] font-bold text-slate-400 hidden sm:block tracking-wide">
                Inventory Management
              </p>
            </div>
          </div>

          {/* Mobile-only Logout Button */}
          <button 
            onClick={() => setShowLogoutModal(true)} 
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-xl bg-red-50/60 border border-red-100 text-red-500 active:scale-95 transition-all"
          >
            <LogOut size={14} strokeWidth={2.5} />
          </button>
        </div>

        {/* ROW 2: CONTROLS */}
        <div className="grid grid-cols-2 md:flex items-center gap-2 md:gap-3 shrink-0">
          
          {/* BRANCH SELECT */}
          <div className="relative w-full md:w-48 shadow-[0_2px_8px_rgba(0,0,0,0.02)] rounded-xl bg-slate-50 border border-slate-200/90 focus-within:border-blue-500 transition-all duration-200 h-10 flex items-center">
            <Building2 size={13} className="absolute left-3 text-slate-400 z-10 pointer-events-none" />
            <select
              value={selectedBranch}
              onChange={handleBranchChange}
              className="w-full h-full bg-transparent pl-9 pr-6 text-[10px] sm:text-[11px] font-black text-slate-700 outline-none appearance-none cursor-pointer truncate"
            >
              {companies.length === 0 ? <option value="">No Profile</option> : 
                companies.map((c) => <option key={c.setting_id} value={String(c.setting_id)}>{c.company_name || `ID: ${c.setting_id}`}</option>)
              }
            </select>
            <div className="absolute right-3 top-1/2 -translate-y-1/2 w-0 h-0 border-l-[3.5px] border-l-transparent border-r-[3.5px] border-r-transparent border-t-[4px] border-t-slate-500 pointer-events-none" />
          </div>

          {/* 🎯 USER PROFILE - SUPER ADMIN FULL TEXT SHOW FIXED */}
          <div className="flex items-center gap-2 bg-gradient-to-b from-white to-slate-50 border border-slate-200 p-1 pr-3 rounded-xl shadow-[0_2px_8px_rgba(0,0,0,0.02)] h-10 w-full md:w-auto">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-tr from-indigo-500 to-violet-600 flex items-center justify-center text-white shrink-0 shadow-sm shadow-indigo-500/20">
              <User size={13} strokeWidth={2.5} />
            </div>
            
            {/* `min-w-0 flex-1` வழங்கப்பட்டுள்ளதால் உரைக்குத் தகுந்தாற்போல் இடம் தானாக விரிவடையும் */}
            <div className="text-left min-w-0 flex-1 flex flex-col justify-center h-full">
              {/* `max-w-none` மற்றும் `truncate` நீக்கப்பட்டதால் பெயர் முழுமையாகத் தெரியும் */}
              <p className="text-[10px] sm:text-[11px] font-black text-slate-800 tracking-tight leading-snug whitespace-nowrap">
                {userData.name}
              </p>
              {/* `truncate` நீக்கப்பட்டு, `whitespace-nowrap` சேர்க்கப்பட்டுள்ளதால் SUPERADMIN முழுமையாகத் தெரியும் */}
              <span className="text-[7.5px] sm:text-[8px] font-black text-indigo-500 uppercase tracking-wider block mt-0.5 leading-none whitespace-nowrap">
                {userData.role}
              </span>
            </div>
          </div>

          {/* Desktop-only Logout Button */}
          <button 
            onClick={() => setShowLogoutModal(true)} 
            className="hidden md:flex w-10 h-10 items-center justify-center rounded-xl bg-white border border-red-100 hover:bg-red-500 text-red-500 hover:text-white transition-all duration-200 shrink-0 shadow-sm hover:shadow-[0_6px_20px_rgba(239,68,68,0.15)] active:scale-95"
          >
            <LogOut size={14} strokeWidth={2.5} />
          </button>
        </div>

      </div>

      {/* CONFIRMATION MODAL */}
      {showLogoutModal && (
        <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center p-0 sm:p-4">
          <div className="absolute inset-0 bg-slate-950/40 backdrop-blur-sm" onClick={() => setShowLogoutModal(false)} />
          <div className="relative bg-white w-full sm:max-w-xs rounded-t-[1.75rem] sm:rounded-2xl p-6 text-center border border-slate-100 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.2)] transform transition-transform duration-300">
            <div className="w-10 h-1 bg-slate-200 rounded-full mx-auto mb-4 sm:hidden" />
            <div className="w-13 h-13 rounded-full bg-red-50 text-red-500 flex items-center justify-center mx-auto mb-3 border-4 border-white shadow-lg shadow-red-500/10">
              <AlertTriangle size={22} />
            </div>
            <h3 className="text-sm sm:text-base font-black text-slate-900 tracking-tight">Confirm Terminal Logout?</h3>
            <p className="text-[11px] sm:text-xs text-slate-400 mt-1.5 px-2 leading-relaxed font-medium">Are you sure you want to end your active session?</p>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 mt-5">
              <button onClick={() => { localStorage.clear(); navigate("/login"); }} className="order-1 sm:order-2 flex-1 py-2.5 rounded-xl bg-gradient-to-r from-red-500 to-rose-600 text-white text-[11px] font-bold shadow-md">Yes, Logout</button>
              <button onClick={() => setShowLogoutModal(false)} className="order-2 sm:order-1 flex-1 py-2.5 rounded-xl border border-slate-200 text-slate-600 text-[11px] font-bold bg-slate-50">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}